import api from '../utilities/api';

export default {
    customPieChart(form, field) {
        return api.v2.get(`graphs/form/${form}/field/${field}`);
    }
}
